(function () {
  try {
    var MARKER = '10_upsell';                         // campaign marker
    var BANNER_ID = 'upsell-10-banner';
    var SESSION_KEY = 'bugmd_' + MARKER;              // marks session as from this campaign
    var CODE_KEY = 'bugmd_discount_code';             // stores last seen discount code for session

    var loc = window.location;
    var params = new URLSearchParams(loc.search || '');

    function getCodeFromUrl() {
      var p = loc.pathname || '';
      if (p.indexOf('/discount/') === 0) {
        var rest = p.slice('/discount/'.length);
        var code = rest.split('/')[0] || '';
        if (code) {
          try { return decodeURIComponent(code); } catch (e) { return code; }
        }
      }
      var fromQuery = params.get('discount');
      return fromQuery ? fromQuery : '';
    }

    // Persist the unique code (useful if you ever need it later in the session)
    var detectedCode = getCodeFromUrl();
    if (detectedCode) {
      sessionStorage.setItem(CODE_KEY, detectedCode);
    }

    // This is the key: Klaviyo links put ?pr=10_upsell on the final URL via the redirect=
    if (params.get('pr') === MARKER) {
      sessionStorage.setItem(SESSION_KEY, '1');
    }

    // Optional QA: show banner if ?preview_upsell=1 (handy in theme preview)
    var preview = params.get('preview_upsell') === '1';

    // Optional fallback if your unique codes are prefixed like "10_upsell_xxx"
    // var looksLikeUpsell = /^10_upsell/i.test(detectedCode || sessionStorage.getItem(CODE_KEY) || '');

    var shouldShow =
      preview ||
      sessionStorage.getItem(SESSION_KEY) === '1';
      // || looksLikeUpsell; // enable if your codes have that prefix

    if (shouldShow) {
      var el = document.getElementById(BANNER_ID);
      if (el) el.hidden = false;
    }
  } catch (e) {
    // no-op
  }
})();
